import {
  ArrowRight,
  CheckCircle,
  ExternalLink,
  FileChartColumnIncreasing,
  FilePlusCorner,
  FingerprintPattern,
  FlaskConical,
  HeartPlus,
  ListChevronsDownUp,
  MapPinCheck,
  PhoneIcon,
  ScrollText,
  Search,
  Trash,
  TriangleAlert,
  User,
  UserSearch,
} from "lucide-react";

export const Icons = {
  HealthPotion: FlaskConical,
  InvestigateCase: FingerprintPattern,
  AdditionalDataIcon: FileChartColumnIncreasing,
  OutSideReportIcon: ScrollText,
  PublicHealthIcon: HeartPlus,
  RightArrowIcon: ArrowRight,
  SearchIcon: Search,
  UserSearchIcon: UserSearch,
  CreateNewIcon: FilePlusCorner,
  DetailsIcon: ListChevronsDownUp,
  UserIcon: User,
  MapPinIcon: MapPinCheck,
  TrashIcon: Trash,
  PhoneIcon: PhoneIcon,
  WarningIcon: TriangleAlert,
  CheckIcon: CheckCircle,
  OpenExternalLinkIcon: ExternalLink,
};
